module.exports = __webpack_public_path__ + "img/head.94208fdb.png";